import React from "react";
import "./WesVerify.css";
const WesVerify = () => {
  return (
    <div className="wesVerifyContainer">
      <h2>
        <span>WES</span> Verification Complications and Confusions
      </h2>
      <p>
        Getting WES verification from universities or other educational
        institutions is challenging for residents and non-residents, especially
        when their location is different from the university’s location. The
        possible solutions for certificate holders are:
      </p>
      <ul>
        <li>
          <span>•</span> Hand over the documents to people traveling to the
          document issuance city/state.
        </li>
        <li>
          <span>•</span> Mail all the documents to friends or relatives living
          near the university to submit the request.
        </li>
        <li>
          <span>•</span> Make multiple trips to universities/colleges for the
          process.
        </li>
      </ul>
      <p>
        <h3>Simplifying Your Complications</h3>
        Goodway Attestation focuses on making the process as simple, easy, and
        secure as possible to save time and avoid wasting money. We cover most
        colleges and universities in India and the Gulf with our presence in
        almost all major cities and states. We also provide services from the
        UK, USA, Australia, etc. We have a standard and speedy procedure for
        getting WES verification for your documents. Our service acts as an
        interface between the university and the student/candidate seeking
        verification for WES Canada and the US. The entire process is
        digitalized, making it hassle-free, fast, and secure for you. The
        applicant is not forced to undergo repetitive regression cycles and
        avoid multiple trips to the university. We know the protocol and the
        university requirements in our database. Our interaction with the
        university and the applicant is clear and accurate. Through us, the
        entire process of getting verification for WES is simple. You must visit
        our office and submit the documents as per the requirements of the
        university and WES. You will receive your verified documents forwarded
        to the desired address within the specified duration.
      </p>
      <p></p>
    </div>
  );
};

export default WesVerify;
